import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import * as React from "react";
import { PageTitle } from "source/components/framework/Page/PageTitle";
import { Base } from "ui/Scripts/source/framework/base";
import { Translations } from "ui/Scripts/source/models/translations";
import { IReportItem } from "../../../../models/report/reportItem";
import { MainListContainer } from "source/components/framework/List/MainListContainer";
import { RecordArchiveExpiredFamiliarizationsDialog } from "../../RecordArchiveExpiredFamiliarizationsDialog";
import { RecordArchiveExpiredFurtherEducationsDialog } from "../../RecordArchiveExpiredFurtherEducationsDialog";
import { RecordExpiredFamiliarizationsList } from "../../RecordExpiredFamiliarizationsList";
import { RecordExpiredFurtherEducationsList } from "../../RecordExpiredFurtherEducationsList";
import { AppButton } from "ui/Scripts/source/components/framework/Button/AppButton";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

/* eslint-disable no-unused-vars */
export const enum HtmlReportId {
  ExpiredFamiliarizations = "HtmlReportExpiredFamiliarizations",
  ExpiredFurtherEducations = "HtmlReportExpiredFurtherEducations",
}
/* eslint-enable no-unused-vars */

export interface IRecordPageListReportHtmlProp {
  companyId: string;
  employeeTypes: number[];
  jobTitles: string[];
  unitIds: string[];
  activityState: number;
  report: IReportItem;
  sortColumn: string;
  sortOrderIsAsc: boolean;
  onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
}

export interface IRecordPageListReportHtmlState {
  reportGenerated: boolean;
  selectedId: string;
  checkedIds: string[];
  dataId: string;
  showArchiveExpiredFamiliarizationsDialog: boolean;
  showArchiveExpiredFurtherEducationsDialog: boolean;
}

export class RecordPageListReportHtml extends React.Component<
  IRecordPageListReportHtmlProp,
  IRecordPageListReportHtmlState
> {
    constructor(props: IRecordPageListReportHtmlProp) {
        super(props);
        this.state = {
            reportGenerated: false,
            selectedId: null,
            checkedIds: [],
            dataId: "",
            showArchiveExpiredFamiliarizationsDialog: false,
            showArchiveExpiredFurtherEducationsDialog: false,
        };
    }

    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.setState({
            reportGenerated: true,
            selectedId,
            checkedIds,
        });
    };

    // #region Additional functions: ArchiveExpiredFamiliarizations
    handleArchiveExpiredFamiliarizations = () => {
        this.setState({
            showArchiveExpiredFamiliarizationsDialog: true,
        });
    };

    handleArchiveExpiredFamiliarizationsDialogOk = () => {
        this.setState({
            showArchiveExpiredFamiliarizationsDialog: false,
            dataId: Base.getGuid(),
        });
    };

    handleArchiveExpiredFamiliarizationsDialogCancel = () => {
        this.setState({
            showArchiveExpiredFamiliarizationsDialog: false,
        });
    };
    // #endregion Additional functions: ArchiveExpiredFurtherEducations

    // #region Additional functions: ArchiveExpiredFurtherEducations
    handleArchiveExpiredFurtherEducations = () => {
        this.setState({
            showArchiveExpiredFurtherEducationsDialog: true,
        });
    };

    handleArchiveExpiredFurtherEducationsDialogOk = () => {
        this.setState({
            showArchiveExpiredFurtherEducationsDialog: false,
            dataId: Base.getGuid(),
        });
    };

    handleArchiveExpiredFurtherEducationsDialogCancel = () => {
        this.setState({
            showArchiveExpiredFurtherEducationsDialog: false,
        });
    };
    // #endregion Additional functions: ArchiveExpiredFurtherEducations

    render() {
        const props = this.props;
        if (!props.report) return null;
        const state = this.state;
        return (
            <VerticalContainer
                before={
                    <PageTitle title={Translations.Reports + (props.report ? " - " + props.report.title : "")} position="absolute">
                        {props.report.reportId === HtmlReportId.ExpiredFamiliarizations && (
                            <AppButton
                                variant="contained"
                                startIcon={<ArchiveOutlinedIcon />}
                                disabled={!state.reportGenerated}
                                onClick={this.handleArchiveExpiredFamiliarizations}
                            >
                                {Translations.ArchiveExpiredFamiliarizations}
                            </AppButton>
                        )}
                        {props.report.reportId === HtmlReportId.ExpiredFurtherEducations && (
                            <AppButton
                                variant="contained"
                                startIcon={<ArchiveOutlinedIcon />}
                                disabled={!state.reportGenerated}
                                onClick={this.handleArchiveExpiredFurtherEducations}
                            >
                                {Translations.ArchiveExpiredFurtherEducations}
                            </AppButton>
                        )}
                    </PageTitle>
                }
                main={
                    <MainListContainer>
                        {props.report.reportId === HtmlReportId.ExpiredFamiliarizations && (
                            <RecordExpiredFamiliarizationsList
                                companyId={props.companyId}
                                isReport={true}
                                employeeTypes={props.employeeTypes}
                                jobTitles={props.jobTitles}
                                unitIds={props.unitIds}
                                activityState={props.activityState}
                                dataId={state.dataId}
                                sortColumn={props.sortColumn}
                                sortOrderIsAsc={props.sortOrderIsAsc}
                                onSetSelectedIds={this.handleSetSelectedIds}
                                onSetSortData={props.onSetSortData}
                            />
                        )}
                        {props.report.reportId === HtmlReportId.ExpiredFurtherEducations && (
                            <RecordExpiredFurtherEducationsList
                                companyId={props.companyId}
                                isReport={true}
                                employeeTypes={props.employeeTypes}
                                jobTitles={props.jobTitles}
                                unitIds={props.unitIds}
                                activityState={props.activityState}
                                dataId={state.dataId}
                                sortColumn={props.sortColumn}
                                sortOrderIsAsc={props.sortOrderIsAsc}
                                onSetSelectedIds={this.handleSetSelectedIds}
                                onSetSortData={props.onSetSortData}
                            />
                        )}
                        {state.showArchiveExpiredFamiliarizationsDialog && (
                            <RecordArchiveExpiredFamiliarizationsDialog
                                companyId={props.companyId}
                                onOk={this.handleArchiveExpiredFamiliarizationsDialogOk}
                                onCancel={this.handleArchiveExpiredFamiliarizationsDialogCancel}
                            />
                        )}
                        {state.showArchiveExpiredFurtherEducationsDialog && (
                            <RecordArchiveExpiredFurtherEducationsDialog
                                companyId={props.companyId}
                                onOk={this.handleArchiveExpiredFurtherEducationsDialogOk}
                                onCancel={this.handleArchiveExpiredFurtherEducationsDialogCancel}
                            />
                        )}
                    </MainListContainer>
                }
            />
        );
    }
}
